<template>
  <div class="view-forgot-password mt-5">
    <div v-if="!sent">
      <div class="animate-right">
        <h2 class="fw-6">
          Esqueceu sua senha?
        </h2>
        <p>Digite seu e-mail cadastrado para recuperar sua senha</p>
      </div>

      <form @submit.prevent="submit">
        <snow-input
          v-model="form.email"
          id="email"
          type="email"
          label="E-mail"
          :rules="rules.email"
        />

        <button
          class="btn mt-6"
          :class="{ loading }"
          type="button"
          :disabled="loading"
          :aria-busy="loading"
          @click="submit"
        >
          <span v-if="!loading">Recuperar senha</span>
          <span v-else class="spinner" aria-hidden="true"></span>
          <span v-if="loading" class="sr-only">Carregando…</span>
        </button>
      </form>

      <p class="text-center mt-6">
        Já tem uma conta?
        <router-link :to="{ name: 'login' }">
          Fazer login
        </router-link>
      </p>
    </div>
    <div v-else>
      <div class="d-flex justify-content-center">
        <lottie-vue-player
          :src="check"
          class="mr-6"
          autoplay
          :speed="0.8"
          :player-controls="false"
          style="width: 136px; background: transparent;"
        />
      </div>
      <p class="text-center mb-6 fs-24">
        Concluído!
      </p>
      <p class="text-center fs-16 mb-9">
        Verifique seu e-mail e siga as instruções de recuperação da senha.
      </p>
      <button class="btn mt-3" type="button" @click="login">Fazer login</button>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  components: {},
  data() {
    return {
      ...formFields(["email"]),
      sent: false,
      loading: false,
      rules: {
        email: [
          v => !!v || "O e-mail é obrigatório",
          v => /.+@.+\..+/.test(v) || "E-mail deve ser válido"
        ]
      }
    };
  },
  computed: {
    check() {
      return JSON.stringify(require("@/assets/check.json"));
    }
  },
  methods: {
    setError(error, field) {
      this.errors[field] = error;
    },
    login() {
      this.$router.push({ name: "login" });
    },
    next() {
      this.choseSegment = true;
    },
    submit() {
      this.$message.hide();
      this.loading = true;

      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(
            window.RECAPTCHA_ENTERPRISE_SITE_KEY,
            { action: "FORGOT_PASSWORD" }
          );
          this._submit(token);
        } catch {
          this.loading = false;
          this.$message.error("Por favor, tente novamente");
        }
      });
    },
    _submit(recaptcha_token) {
      this.$store
        .dispatch("user/forgot", {
          ...this.form,
          recaptcha_token
        })
        .then(() => {
          this.sent = true;
        })
        .catch(error => {
          if (error.response.data.message) {
            this.$message.error(error.response.data.message[0]);
          } else if (!this.errors.email[0]) {
            this.errors = error.response.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-forgot-password {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
